<template>
  <div>
    <div class="important-info-sec">
      <div class="important-info-blurbs">
        <div class="container">
          <div class="row offset-position">
            <div class="col-md-4">
              <div class="blurb-info">
                <div class="content-info">
                  <span>{{endValOne}}</span>
                  <span>%</span>

                  <p class="porcent-text">De los puntajes máximos nacionales</p>
                </div>
                <div class="content-info-box"></div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="blurb-info">
                <div class="content-info">
                  <span>39</span>
                  <p class="porcent-text">Sedes a lo largo de todo el país</p>
                </div>
                <div class="content-info-box"></div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div
        class="programs-info"
        data-aos="fade-down"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h3 class="title">Beneficios de estudiar en el Preu PDV</h3>
            </div>
          </div>
          <div class="five-sections">
            <div class="program-info-item-container">
              <div class="program-info-item">
                <img src="/images/svgs/360.svg" alt="" />
                <p>
                  Líder en Puntajes
                </p>
              </div>
            </div>

            <div class="program-info-item-container">
              <div class="program-info-item">
                <img
                  src="/images/svgs/profesores.svg"
                  alt=""
                />
                <p>
                  Excelencia Académica
                </p>
              </div>
            </div>

            <div class="program-info-item-container">
              <div class="program-info-item">
                <img src="/images/svgs/ejercitacion.svg" alt="" />
                <p>
                  Programas Personalizados
                </p>
              </div>
            </div>
            <div class="program-info-item-container">
              <div class="program-info-item">
                <img src="/images/iconos/interactivas.svg" alt="" />
                <p>
                  Variedad de precios para todos
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      endValOne: 0,
      endValTwo: 0,
      endValThree: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: ''
      }
    };
  },

  methods: {
    onReady() {
      this.endValOne = 52;
      this.endValTwo = 37;
      this.endValThree = 211;
    }
  },
  mounted() {
    this.onReady()
  }
};
</script>

<style lang="scss" scoped>
.important-info-blurbs {
  background: $yellow;
  height: 160px;
  padding: 65px 0;
  position: relative;
  @include media-breakpoint-down(sm) {
    padding: 58px 0 0;
    height: 120px;
  }
}

/*
    .important-info-blurbs:before{
        content: '';
        width: 55%;
        height: 120px;
        position: absolute;
        left: 0;
        bottom:-90px;
        background: #fff;
        transform: skewY(4deg);
        z-index: 10;
    }

    .important-info-blurbs:after {
        content: '';
        width: 55%;
        height: 120px;
        position: absolute;
        right: 0;
        bottom: -90px;
        background: #fff;
        transform: skewY(-4deg);
        z-index: 10;
    }
    */

.blurb-info {
  position: relative;
  height: 139px;
  background: #ffffff;
  // border-radius: 30px;
  .content-info {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    padding: 8px 0;
    margin-left: 20px;
    @include media-breakpoint-down(md) {
      margin-left: 0;
    }
    @include media-breakpoint-down(sm) {
      margin-left: 20px;
    }
    span {
      color: #000;
      @include Gotham-Black;
      font-size: 58px;
      letter-spacing: -0.7px;
      line-height: 55px;
    }
    h4 {
      font-size: 20px;
      line-height: 21px;
      margin-bottom: 2px;
      @include font-light-regular();
    }
    p {
      margin-left: 20px;
      margin-bottom: 0;
      max-width: 160px;
      @include Gotham-Medium();
      font-size: 15px;
      letter-spacing: -0.18px;
      line-height: 17px;
      @media screen and (max-width: 768px) and (min-width: 600px) {
        margin-left: 0 !important;
      }
      @include media-breakpoint-down(md) {
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }
  @include media-breakpoint-down(sm) {
    margin-bottom: 19px;
  }
}

.programs-info {
  background: transparent;
  padding: 62px 0 52px;
  z-index: 10;
  position: relative;
  
  @media screen and (max-width: 430px) {
    padding: 28px 0 95px 0;
    
  }


  .title {
    @include font-bold;
    font-size: 40px;
    letter-spacing: -0.48px;
    line-height: 50px;
    text-align: center;
    // color: $yellow;
    margin-bottom: 65px;
    color: #000;
    @include media-breakpoint-down(sm) {
      font-size: 30px;
      letter-spacing: -0.36px;
      line-height: 41px;
      text-align: center;
      margin-bottom: 0;
    }
  }
  .program-info-item {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 32px 0;
    img {
      height: 77px;
      margin-bottom: 27px;
    }
    p {
      font-size: 20px;
      line-height: 22px;
      letter-spacing: -0.24px;
      line-height: 28px;
      text-align: center;
      @include alternative-regular;
      color: #000;
      width: 100%;
      max-width: 191px;
      @media screen and (max-width: 430px) {
        margin-bottom: 0;
        max-width: 320px;
      }
    }
  }
}
.offset-position{
  margin-top: -105px;
  justify-content: center;
    @include media-breakpoint-down(sm) {
      margin-top: 0px;
    }
}
.five-sections{
  
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: -45px;
  @include media-breakpoint-down(md) {
    margin-left: 0;
    
    flex-flow: row;
    justify-content: center;
    align-items: center;
  }
  @media screen and (max-width: 1024px) {
    margin-left: 0;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
}
// .program-info-item-container{
//   display: flex;
//   &:nth-child(1) {
//     .program-info-item{
//       display: flex;
//       align-items: center;
//       justify-content: flex-start;
//       flex-direction: column;
//       width: 191px;
//       @include media-breakpoint-down(md) {
//         width: 100%;
//       }
//       img {
//         width:79px;
//         height: 74px;
//         margin-bottom: 40px;
//         @include media-breakpoint-down(md) {
//           margin-bottom: 26px;
//         }
//       }
//     }
//     margin: 0 30px;
//     @include media-breakpoint-down(md) {
//       margin: 0;
//     }
//   }
//   &:nth-child(2) {
//     .program-info-item{
//       display: flex;
//       align-items: center;
//       justify-content: flex-start;
//       flex-direction: column;
//       width: 188px;
//       @include media-breakpoint-down(md) {
//         width: 100%;
//       }
//       img{
//         width: 74;
//         height: 74;
//         margin-bottom: 40px;
//         @include media-breakpoint-down(md) {
//           margin-bottom: 17px;
//         }
//       }
//     }
//     margin: 0 30px;
//     @include media-breakpoint-down(md) {
//       margin: 0;
//     }
//   }
//   &:nth-child(3) {
//     .program-info-item{
//       display: flex;
//       align-items: center;
//       justify-content: flex-start;
//       flex-direction: column;
//       width: 208px;
//       @include media-breakpoint-down(md) {
//         width: 100%;
//       }
//       img{
//         width: 71px;
//         height: 74px;
//         margin-bottom: 40px;
//         @include media-breakpoint-down(md) {
//           margin-bottom: 17px;
//         }
//       }
//     }
//     margin: 0 30px;
//     @include media-breakpoint-down(md) {
//       margin: 0;
//     }
//   }
//   &:nth-child(4) {
//     .program-info-item{
//       display: flex;
//       align-items: center;
//       justify-content: flex-start;
//       flex-direction: column;
//       width: 202px;
//       @include media-breakpoint-down(md) {
//         width: 100%;
//       }
//       img{
//         width: 75px;
//         height: 74px;
//         margin-bottom: 40px;
//         @include media-breakpoint-down(md) {
//           margin-bottom: 17px;
//         }
//       }
//     }
//     margin: 0 30px;
//     @include media-breakpoint-down(md) {
//       margin: 0;
//     }
//   }
//   &:nth-child(5) {
//     .program-info-item{
//       display: flex;
//       justify-content: flex-start;
//       align-items: center;
//       flex-direction: column;
//       width: 192px;
//       @include media-breakpoint-down(md) {
//         width: 100%;
//       }
//       img {
//         width: 52px;
//         height: 74px;
//         margin-bottom: 40px;
//         @include media-breakpoint-down(md) {
//           margin-bottom: 17px;
//         }
//       }
//     }
//     margin-left: 30px;
//     @include media-breakpoint-down(md) {
//       margin: 0;
//     }
//   }
// }


.porcent-text{
  color: #000;
  // margin-right: 20px;
}
</style>
